import { Alert, Cell, FormControl, Grid, Heading, HFlow, Text } from 'bold-ui'
import { CheckboxField, NumberField } from 'components/form'
import { RequiredLabel } from 'components/form/final-form/RequiredLabel/RequiredLabel'
import { LotacaoResponsavelSection } from 'components/lotacao-responsavel/LotacaoResponsavelSection'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import { ResponsabilidadeAcompanhamentoFormModel } from '../model-cidadaoFci'

interface ResponsabilidadeAcompanhamentoSectionProps {
  meta: MetaPath<ResponsabilidadeAcompanhamentoFormModel>
  values: ResponsabilidadeAcompanhamentoFormModel
  cidadaoFaleceu: boolean
  isLotacaoActive: boolean
}
export const ResponsabilidadeAcompanhamentoSection = ({
  meta,
  values,
  cidadaoFaleceu,
  isLotacaoActive,
}: ResponsabilidadeAcompanhamentoSectionProps) => {
  return (
    <Grid>
      <Cell size={12}>
        <Heading level={2}>Responsabilidade de Acompanhamento</Heading>
      </Cell>
      <Cell size={12}>
        <LotacaoResponsavelSection name={meta.responsavel} isCadastroIndividual />
      </Cell>
      <Cell size={12}>
        {isLotacaoActive === false && (
          <Alert type='danger' inline>
            O responsável informado possui uma lotação inativa. Atualize para a nova lotação alterando o responsável.
          </Alert>
        )}
      </Cell>
      <Cell size={3}>
        <NumberField
          name={meta.microarea}
          disabled={values?.statusForaArea}
          label={
            <HFlow hSpacing={0.5} alignItems='center'>
              {!values?.statusForaArea ? <RequiredLabel label='Microarea' /> : <Text>Microarea</Text>}
            </HFlow>
          }
          maxLength={2}
        />
      </Cell>
      <Cell size={4}>
        <FormControl label={<span>&nbsp;</span>}>
          <CheckboxField name={meta.statusForaArea} label='Fora de área' />
        </FormControl>
      </Cell>
      <Cell size={5} />
      <Cell size={4}>
        <CheckboxField
          name={meta.statusCidadaoSaiuTerritorio}
          label='Cidadão saiu do território'
          disabled={cidadaoFaleceu}
        />
      </Cell>
      <Cell size={8} />
    </Grid>
  )
}
